import axios from "axios";
import Cookies from "js-cookie";
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
const controllerMap = new Map(); // Tracks /default request controllers

// Add token to Authorization header for all requests
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token") || Cookies.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const url = config.url || "";

    // If new request is a /search request, cancel all /default requests
    if (url.includes("/search")) {
      for (const [key, controller] of controllerMap.entries()) {
        if (key.includes("/default")) {
          controller.abort(); // Cancel the request
          controllerMap.delete(key); // Clean up
        }
      }
    }

    // If this is a /default request, assign an AbortController
    if (url.includes("/default")) {
      const controller = new AbortController();
      config.signal = controller.signal;
      controllerMap.set(url, controller);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // Remove the controller for completed /default requests
    const url = response.config.url;
    if (url.includes("/default")) {
      controllerMap.delete(url);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 403) {
      // 1. clear out any stored token/user
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      Cookies.remove("token");
      Cookies.remove("user");

      // 2. notify the user
      alert("You’ve been logged out because your session was ended elsewhere.");

      // 3. redirect to /login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
